export default "__VITE_ASSET__DQuz_i9J__"